(function () {
  var API_BASE = 'https://api.okendo.io/v1/stores';
  var MAX_VISIBLE_REVIEWS = 250;
  var AGGREGATE_CACHE = {};
  var REVIEWS_CACHE = {};

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function starsHtml(rating, max) {
    max = max || 5;
    var r = Math.round(Number(rating) || 0);
    var out = '';
    for (var i = 1; i <= max; i++) out += i <= r ? '★' : '☆';
    return out;
  }

  function formatAverage(aggregate) {
    if (!aggregate || !aggregate.reviewCount) return '0';
    if (aggregate.reviewAverageValue != null) return Number(aggregate.reviewAverageValue).toFixed(1);
    if (aggregate.reviewRatingValuesTotal != null) {
      return (aggregate.reviewRatingValuesTotal / aggregate.reviewCount).toFixed(1);
    }
    return '0';
  }

  function normalizeProductId(id) {
    if (id == null) return null;
    return String(id).replace(/^shopify-/i, '').trim();
  }

  function resolveStoreId(root) {
    var fromRoot = root.getAttribute('data-store-id');
    if (fromRoot) return fromRoot.trim();
    var meta = document.querySelector('meta[name="oke:subscriber_id"]');
    if (meta && meta.content) return meta.content.trim();
    return '';
  }

  function parseInitial(root) {
    var el = root.querySelector('[data-initial-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseVariantReviewMap(root) {
    var el = root.querySelector('[data-variant-review-map]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectedVariantId(mainRoot) {
    if (!mainRoot) return null;
    var form = mainRoot.querySelector('form[data-variants]');
    if (form) {
      var selected = form.querySelector('[name="id"]');
      if (selected && selected.value) return selected.value;
    }
    var input = mainRoot.querySelector('.metafield-variations-pill-input:checked');
    return input ? input.getAttribute('data-variant-id') : null;
  }

  function mappedProductIdFromVariant(root, variantId) {
    if (!root || !variantId) return null;
    var map = parseVariantReviewMap(root);
    if (!map || !map.byVariantId) return null;
    return normalizeProductId(map.byVariantId[String(variantId)]);
  }

  function productIdFromMainSection(mainRoot) {
    if (!mainRoot) return null;
    var marker = mainRoot.querySelector('[data-flavor-section-render]');
    if (marker) {
      var id = marker.getAttribute('data-current-product-id');
      if (id) return id.trim();
    }
    var productTemplate = mainRoot.querySelector('[data-product-handle]');
    if (!productTemplate) return null;
    var handle = productTemplate.getAttribute('data-product-handle');
    return handle ? { handle: handle } : null;
  }

  function resolveProductId(idOrHandle) {
    if (!idOrHandle) return Promise.resolve(null);
    if (typeof idOrHandle === 'string') return Promise.resolve(idOrHandle);
    if (!idOrHandle.handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(idOrHandle.handle) + '.json', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product json');
        return res.json();
      })
      .then(function (data) {
        return data && data.product ? String(data.product.id) : null;
      })
      .catch(function () {
        return null;
      });
  }

  function updateTopSummary(aggregate) {
    var summary = document.querySelector('[data-performance-okendo-star-summary]');
    if (!summary) return;
    var starsEl = summary.querySelector('[data-star-summary-stars]');
    var countEl = summary.querySelector('[data-star-summary-count]');
    var linkEl = summary.querySelector('[data-star-summary-link]');
    var labelEl = summary.querySelector('.performance-okendo-star-summary__label');
    var count = (aggregate && (aggregate.reviewCount || aggregate.ratingAndReviewCount)) || 0;
    var avg = formatAverage(aggregate || {});
    if (starsEl) starsEl.textContent = starsHtml(Math.round(parseFloat(avg)));
    if (countEl) countEl.textContent = count > 0 ? count.toLocaleString() : '0';
    if (linkEl) linkEl.style.pointerEvents = count > 0 ? '' : 'none';
    if (labelEl) labelEl.textContent = count === 1 ? 'verified review' : 'verified reviews';
    summary.hidden = false;
  }

  function buildBars(aggregate, barsEl) {
    if (!barsEl || !aggregate) return;
    var byLevel = aggregate.reviewCountByLevel || aggregate.ratingAndReviewCountByLevel;
    var total = aggregate.reviewCount || aggregate.ratingAndReviewCount || 0;
    if (!byLevel || !total) {
      barsEl.innerHTML = '';
      return;
    }
    var levels = [
      { key: 'level5Count', star: 5 },
      { key: 'level4Count', star: 4 },
      { key: 'level3Count', star: 3 },
      { key: 'level2Count', star: 2 },
      { key: 'level1Count', star: 1 },
    ];
    var html = '';
    levels.forEach(function (lvl) {
      var count = byLevel[lvl.key] || 0;
      var pct = total ? Math.round((count / total) * 100) : 0;
      html +=
        '<div class="performance-pdp-okendo-reviews__bar-row">' +
        '<span class="performance-pdp-okendo-reviews__bar-label">' +
        lvl.star +
        '★</span>' +
        '<div class="performance-pdp-okendo-reviews__bar-track">' +
        '<div class="performance-pdp-okendo-reviews__bar-fill" style="width:' +
        pct +
        '%;"></div></div>' +
        '<span class="performance-pdp-okendo-reviews__bar-pct">' +
        pct +
        '%</span></div>';
    });
    barsEl.innerHTML = html;
  }

  function updateHead(root, aggregate, shownCount) {
    var countEl = root.querySelector('[data-review-count]');
    var avgEl = root.querySelector('[data-review-average]');
    var starsEl = root.querySelector('[data-title-stars]');
    var seeAllBtn = root.querySelector('[data-see-all]');
    var count = aggregate.reviewCount || aggregate.ratingAndReviewCount || 0;
    var avg = formatAverage(aggregate);
    var countLabel = count === 1 ? '1 review' : count.toLocaleString() + ' reviews';
    if (countEl) countEl.textContent = countLabel;
    if (avgEl) avgEl.textContent = avg + ' average.';
    if (starsEl) starsEl.textContent = starsHtml(Math.round(parseFloat(avg)));
    if (seeAllBtn) {
      seeAllBtn.dataset.totalReviews = String(count);
      var displayed = Number(shownCount || 0);
      var currentLimit = Number(root.getAttribute('data-current-limit') || 0);
      if (count === 0) {
        seeAllBtn.hidden = true;
      } else if (displayed >= MAX_VISIBLE_REVIEWS || currentLimit >= MAX_VISIBLE_REVIEWS) {
        seeAllBtn.textContent = 'Show fewer reviews →';
        seeAllBtn.dataset.mode = 'collapse';
        seeAllBtn.hidden = false;
      } else if (displayed >= count) {
        seeAllBtn.textContent = 'Show fewer reviews →';
        seeAllBtn.dataset.mode = 'collapse';
        seeAllBtn.hidden = false;
      } else {
        seeAllBtn.textContent = 'See all ' + count.toLocaleString() + ' reviews →';
        seeAllBtn.dataset.mode = 'expand';
        seeAllBtn.hidden = false;
      }
    }
  }

  function showLoadingGrid(root, limit) {
    var grid = root.querySelector('[data-reviews-grid]');
    if (!grid) return;
    var n = parseInt(limit, 10) || 6;
    var html = '';
    for (var i = 0; i < n; i++) {
      html += '<div class="performance-pdp-okendo-reviews__skeleton-card" aria-hidden="true"></div>';
    }
    grid.innerHTML = html;
    var section = root.closest('.performance-pdp-okendo-reviews');
    if (section) section.classList.add('is-loading');
  }

  function renderCards(grid, reviews) {
    if (!reviews || !reviews.length) {
      grid.innerHTML = '<p class="performance-pdp-okendo-reviews__empty">No reviews yet for this product.</p>';
      return;
    }
    grid.innerHTML = reviews
      .map(function (review) {
        var name = (review.reviewer && review.reviewer.displayName) || 'Customer';
        var verified = review.reviewer && review.reviewer.isVerified ? ', verified buyer' : '';
        return (
          '<article class="performance-pdp-okendo-reviews__card">' +
          '<div class="performance-pdp-okendo-reviews__card-stars" aria-hidden="true">' +
          starsHtml(review.rating) +
          '</div>' +
          (review.title
            ? '<h3 class="performance-pdp-okendo-reviews__card-title">' + escapeHtml(review.title) + '</h3>'
            : '') +
          '<p class="performance-pdp-okendo-reviews__card-body">' +
          escapeHtml(review.body || '') +
          '</p>' +
          '<p class="performance-pdp-okendo-reviews__card-author">— ' +
          escapeHtml(name) +
          escapeHtml(verified) +
          '</p></article>'
        );
      })
      .join('');
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function loadReviews(root, productIdOverride, limitOverride) {
    var productId = normalizeProductId(productIdOverride || root.getAttribute('data-product-id'));
    var storeId = resolveStoreId(root);
    var defaultLimit = parseInt(root.getAttribute('data-limit') || '6', 10);
    var limit = parseInt(limitOverride || defaultLimit, 10);
    var grid = root.querySelector('[data-reviews-grid]');
    var barsEl = root.querySelector('[data-rating-bars]');

    if (!productId || !storeId) {
      root.classList.remove('is-loading');
      if (grid) {
        grid.innerHTML =
          '<p class="performance-pdp-okendo-reviews__error">Reviews unavailable — add Okendo Storefront API store ID in Theme settings → Performance PDP.</p>';
      }
      return Promise.resolve();
    }

    root.setAttribute('data-product-id', productId);
    root.setAttribute('data-current-limit', String(limit));

    var cacheKey = productId + '::' + limit;
    var cachedAggregate = AGGREGATE_CACHE[cacheKey];
    var cachedReviews = REVIEWS_CACHE[cacheKey];
    if (cachedAggregate && cachedReviews) {
      updateHead(root, cachedAggregate, cachedReviews.length);
      buildBars(cachedAggregate, barsEl);
      renderCards(grid, cachedReviews);
      updateTopSummary(cachedAggregate);
      root.classList.remove('is-loading');
      var cachedSection = root.closest('.performance-pdp-okendo-reviews');
      if (cachedSection) cachedSection.classList.remove('is-loading');
      return Promise.resolve();
    }

    showLoadingGrid(root, limit);

    var base =
      API_BASE +
      '/' +
      encodeURIComponent(storeId) +
      '/products/' +
      encodeURIComponent('shopify-' + productId);

    var initial = parseInitial(root);

    return Promise.all([
      fetchJson(base + '/review_aggregate'),
      fetchJson(base + '/reviews?limit=' + limit + '&orderBy=date%20desc'),
    ])
      .then(function (results) {
        var aggregate = (results[0] && results[0].reviewAggregate) || initial || {};
        var reviews = (results[1] && results[1].reviews) || [];
        AGGREGATE_CACHE[cacheKey] = aggregate;
        REVIEWS_CACHE[cacheKey] = reviews;
        updateHead(root, aggregate, reviews.length);
        buildBars(aggregate, barsEl);
        renderCards(grid, reviews);
        updateTopSummary(aggregate);
        root.classList.remove('is-loading');
        var section = root.closest('.performance-pdp-okendo-reviews');
        if (section) section.classList.remove('is-loading');
      })
      .catch(function () {
        root.classList.remove('is-loading');
        var section = root.closest('.performance-pdp-okendo-reviews');
        if (section) section.classList.remove('is-loading');
        if (!initial && grid) {
          grid.innerHTML =
            '<p class="performance-pdp-okendo-reviews__error">Unable to load reviews. Please try again later.</p>';
        }
      });
  }

  function bindSeeAll(root) {
    var seeAllBtn = root.querySelector('[data-see-all]');
    if (!seeAllBtn || seeAllBtn.getAttribute('data-bound') === 'true') return;
    seeAllBtn.setAttribute('data-bound', 'true');
    seeAllBtn.addEventListener('click', function () {
      var productId = root.getAttribute('data-product-id');
      var mode = seeAllBtn.dataset.mode || 'expand';
      var total = parseInt(seeAllBtn.dataset.totalReviews || '0', 10);
      var defaultLimit = parseInt(root.getAttribute('data-limit') || '6', 10);
      if (mode === 'collapse') {
        loadReviews(root, productId, defaultLimit);
      } else {
        var targetLimit = total > 0 ? Math.min(total, 250) : 100;
        loadReviews(root, productId, targetLimit);
      }
    });
  }

  function reloadForVariant(mainRoot, variantIdOverride) {
    var root = document.querySelector('[data-performance-okendo-reviews]');
    if (!root || !mainRoot) return;

    var variantId = variantIdOverride || selectedVariantId(mainRoot);
    var mappedId = mappedProductIdFromVariant(root, variantId);
    var idPromise = mappedId
      ? Promise.resolve(mappedId)
      : resolveProductId(productIdFromMainSection(mainRoot));

    idPromise.then(function (productId) {
      if (!productId || String(productId) === String(root.getAttribute('data-product-id'))) return;
      var initialJson = root.querySelector('[data-initial-json]');
      if (initialJson) initialJson.remove();
      loadReviews(root, productId);
    });
  }

  function initSection(sectionEl) {
    var root =
      sectionEl.querySelector('[data-performance-okendo-reviews]') ||
      (sectionEl.matches && sectionEl.matches('[data-performance-okendo-reviews]') ? sectionEl : null);
    if (!root) return;

    root.setAttribute('data-initialized', 'true');
    bindSeeAll(root);
    loadReviews(root);

    var mainRoot = document.getElementById('product-template');
    if (mainRoot) {
      window.setTimeout(function () {
        reloadForVariant(mainRoot, selectedVariantId(mainRoot));
      }, 0);
    }
  }

  function initAll() {
    document.querySelectorAll('.performance-pdp-okendo-reviews').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt.target) return;
    var host = evt.target.querySelector('.performance-pdp-okendo-reviews') || evt.target;
    if (host.classList && host.classList.contains('performance-pdp-okendo-reviews')) {
      initSection(host);
      return;
    }
    if (host.querySelector && host.querySelector('[data-performance-okendo-reviews]')) {
      initSection(host);
    }
  });

  document.addEventListener('product:flavor-section-swapped', function (evt) {
    var mainRoot = evt.detail && evt.detail.root;
    if (!mainRoot) return;
    window.setTimeout(function () {
      reloadForVariant(mainRoot);
    }, 20);
  });

  document.addEventListener('performance-pdp:flavor-variant-changed', function () {
    var mainRoot = document.getElementById('product-template');
    if (!mainRoot) return;
    window.setTimeout(function () {
      reloadForVariant(mainRoot);
    }, 20);
  });

  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!t || !t.classList || !t.classList.contains('metafield-variations-pill-input')) return;
    var mainRoot = document.getElementById('product-template');
    if (!mainRoot) return;
    window.setTimeout(function () {
      reloadForVariant(mainRoot, t.getAttribute('data-variant-id'));
    }, 20);
  });

  window.addEventListener('variantChange.ecomify.product', function (evt) {
    var mainRoot = document.getElementById('product-template');
    if (!mainRoot) return;
    window.setTimeout(function () {
      reloadForVariant(mainRoot, evt && evt.detail ? evt.detail.id : null);
    }, 20);
  });

  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('[data-star-summary-link]') : null;
    if (!link) return;
    var target = document.getElementById('performance-pdp-reviews');
    if (!target) return;
    evt.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
